import React from 'react'
import WalkinsCard from '../widgets/walkInsCard/WalkinsCard';

function SimilarWalkins({Similar_walkins}) {
    return (
        <div className='similarWalkins-containner'>
            <p className='Similar m-0'>
            Similar Walk-ins
            </p>
{Similar_walkins?.map((element,index)=><WalkinsCard key={index} detials={element} landingage='d sim ' customClassName={" s w "} similar_flag={false}></WalkinsCard>)}
        </div>
    )
}

export default SimilarWalkins
